// extracted by mini-css-extract-plugin
module.exports = {"emailComposeSendErrorText":"EmailCompose_emailComposeSendErrorText__3DfN_"};